import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { DivisionTreeComponent } from './divisionTree.component';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { DirectivesModule } from '../../directives/directives.module';
import { A11yModule } from '@angular/cdk/a11y';
import { SubHeaderModule } from '../common/sub-header/sub-header.module';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TreeModule } from 'primeng-lts/tree';

@NgModule({
  declarations: [DivisionTreeComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    TreeModule,
    DynamicDialogModule,
    DirectivesModule,
    A11yModule,
    SubHeaderModule,
    ScrollPanelModule
  ],
  exports: [DivisionTreeComponent, DirectivesModule]
})
export class DivisionTreeModule { }
